import React from "react";
import LoginMobileNumber from "./views/LoginMobileNumber";
import { LoginMobileNumberContextProvider } from "./LoginMobileNumberview";
import LoginContent from "../../../../constants/contentFile.json";

const Login = () => {
  return (
    <LoginMobileNumberContextProvider>
      <LoginMobileNumber textContents={LoginContent.loginPage} />
    </LoginMobileNumberContextProvider>
  );
};

export default Login;
